import React from 'react';

import styled from 'styled-components';

import { useContactsSelectorDispatch } from '@components/ContactsSelector/Common/ContactsSelectorContext';
import { FilterDrawerAction } from '@components/Filters/FilterForm/FilterFormUI';
import { NwButton } from '@components/Gui/NwButton';

import ContactsFilterDrawerSections from './ContactsFilterDrawerSections';

const FormWrapper = styled.div`
    margin-bottom: 6rem;
`;

const ContactsFilterDrawer = () => {
    const cs_dispatch = useContactsSelectorDispatch();
    const onSearchClick = () => {
        cs_dispatch({ type: 'ApplyWorkingFilters' });
    };

    return (
        <FormWrapper>
            <ContactsFilterDrawerSections />
            <FilterDrawerAction fullWidth justifyContent="center">
                <NwButton primary label="Search" onClick={onSearchClick} />
            </FilterDrawerAction>
        </FormWrapper>
    );
};

export default ContactsFilterDrawer;
